export const forums = {
  forumsSearchInputPlaceholder: 'Пошук',
  forumsFollowDiscussionButtonTitle: 'Стежити',
  forumsFollowingDiscussButtonTitle: 'Стежиш',
  forumDiscussionInfoNoReplyText: 'Жодної відповіді',
  forumsDiscussionDetailsStartButtonTitle: 'Створити дискусію',
  forumDetailsCreatedByText: 'від',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Скопіювати посилання',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Поскаржитись',
  forumsReportedCurtainContent: 'Скаргу надісланно',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Посилання скопійовано!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Закріпити дискусію',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Відкрипити дискусію',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Редагувати дискусію',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Видалити дискусію',
  forumsDiscussionDetailspPopupDeleteTitle: 'Видалення',
  forumsDiscussionDetailspPopupDeleteText: 'Видалити цю дискусію?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Скасувати',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Підтвердити',
  forumsDiscussionDetailsDeleledAlertText: 'Дискусію видалено!',
  forumsNewDiscussionTitle: 'Нова дискусія',
  forumsNewDiscussionTitlePlaceholder: 'Назва…',
  forumsNewDiscussionBodyPlaceholderText: 'Текст дискусії…',
  forumsNewDiscussionPublishButtonTitle: 'Опублікувати',
  forumsNewDiscussionLocationCurtainTitle: 'Локація',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Назва локації',
  forumsNewDiscussionEditLocationCurtainText: 'Редагувати локацію',
  forumsNewDiscussionDeleteLocationCurtainText: 'Видалити локацію',
  forumsNewDiscussionCreatePollTitle: 'Створити опитування',
  forumsNewDiscussionTitleInputPlaceholder: 'Назва',
  forumsNewDiscussionOptionInputPlaceholder: 'Варіант',
  forumsNewDiscussionAddButtonTitle: 'Додати варіант',
  forumsNewDiscussionCreateButtonTitle: 'Створити',
  forumsNewDiscussionPollTitleBlankAlertText: 'Заповніть поле',
  forumsNewDiscussionPollOptionBlankAlertText: 'Заповніть поле',
  forumsNewDiscussionPollLongTitleAlertText: 'Задовга назва, оберіть не довше 140 символів',
  forumsNewDiscussionPollLongOptionAlertText: 'Задовгий варіант, оберіть не довше 50 символів',
  forumsNewDiscussionEditPollIconText: 'Редагувати опитування',
  forumsNewDiscussionRemovePollIconText: 'Видалити опитування',
  forumsDiscardDraftPopupTitle: 'Чернетка',
  forumsDiscardDraftPopupText: 'Видалити цю чернетку?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Скасувати',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Підтвердити',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Відповісти',
  forumsDiscussionDetailsNoCommentsText: 'Жодних коментарів\nЗалиште перший коментар',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Відповісти',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Скопіювати посилання',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Посилання скопійовано!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Поскаржитись',
  forumsDiscussionDetailsPostCurtainReportedText: 'Скаргу надіслано',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Відповісти',
  forumsEditDiscussionTitle: 'Редагувати дискусію',
  forumsEditDiscussionSaveButtonTitle: 'Зберегти',
  forumsEditedDiscussionSavedAlertText: 'Дискусію збережено!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Редагувати відповідь',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Видалити відповідь',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Коментар збережено!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Коментар видалено!',
  forumsAlertSomethinWrong: 'Щось пішло не так!',
  forumsMaxMbSize: 'Ви не можете завантажити більше {size} МБ за один раз',
  forumsMaxAttachments: 'Ви перевищили максимальну кількість фотографій. Максимальна кількість становить {max} фото',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Видалення',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Видалити цей коментар?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Скасувати',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Підтвердити',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Поскаржитись',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Скаргу надіслано',
  forumDiscussionInfoLastReplyText: 'Остання відповідь',
  forumsDiscussionAt: 'у',
  forumsDiscussionDetailsFlagCurtainTitle: 'Поскаржитись',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Скаргу надіслано',
  forumsPollInfoVotesText: 'голосів',
  forumsPollInfoEditVoteText: 'Переголосувати',
  forumsPollFinishPollText: 'Завершити',
  forumsPollFinishedPollText: 'Завершено',
  forumsPollInProgresslText: 'В процесі',
  forumsPollCurtainTitle: 'Завершити',
  forumsPollCurtainText: 'Користувачі більше не зможуть голосувати в цьому опитуванні, коли воно буде закінчено.',
  forumsFinishPollCurtainCancelButtonTitle: 'Скасувати',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Підтвердити',
  forumsPollInfoPollVotesCurtainTitle: 'Голоси'
}
